module.exports = __webpack_public_path__ + "static/img/logo.7714a3d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.svg
// module id = 284
// module chunks = 1